export const regexCleanup = (term: string): string => {
  return term.replace(/[\\[\]/{}()*+?\\^$|]/g, '');
};
